// extracted by mini-css-extract-plugin
export default {"instructions":"Instructions__instructions___3yCAQ"};